export class AdditionalDocumentPayload {
    public accessToken: string = '';
    public documentName: string = '';
    public documentFile: any;
    public effectiveDate: string = '';
    public documentType: string ='';
    public expiryDate: string = '';
    public documentId: number = 0;
    public licenseState: string = '';
    public licenseNumber: string = '';
    public doesNotExpire: boolean = false;
  }